var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85 40.8q-1.436 0-2.543-1.116T3.2 37.15v-26.3q0-1.418 1.107-2.534T6.85 7.2H20.4l3.65 3.65h17.1q1.418 0 2.534 1.116T44.8 14.5v22.65q0 1.418-1.116 2.534T41.15 40.8z"
  })));
};
export default SvgFolder;